window.$ = window.jQuery = require('jquery');
import Vgnav from 'vgnav/dist/js/vgnav';
window.VGNav = Vgnav;
window.AOS = require('aos/dist/aos');
window.sortable = require('jquery-ui/ui/widgets/sortable');
window.moment = require('moment');
require('../../vendor/touchpunch/jquery.ui.touch-punch.min');
window.VimeoPlayer = require('@vimeo/player/src/player').default;
window.rescalendar = require('./../../vendor/rescalendar/rescalendar.min');

require('jquery.scrollbar/jquery.scrollbar');
require('vgformsender/dist/js/vgformsender.min');
require('vgscrollto/dist/js/vgscrollto.min');
require('popper.js/dist/popper.min');
require('bootstrap');
require('jquery-nice-select/js/jquery.nice-select.min');
require('@fancyapps/fancybox/dist/jquery.fancybox');
require('inputmask/dist/inputmask');
require('../../vendor/draggable-touch/jquery.draggableTouch');

require('../../vendor/modules/bg');
require('../../vendor/modules/modal');
require('../../vendor/modules/mask');
require('../../vendor/modules/carousel');
require('../../vendor/parallax/parallax.min');

require('./modules/parallax');
require('./modules/date-countdown');
require('./modules/swipeContent');
/*require('./modules/snowfall');*/
require('./modules/autumn');
require('./modules/spring');
require('./modules/vegas');
require('./modules/ym');
require('./functions');

require('./modules/auth');
require('./modules/cart');
require('./modules/promocode');
require('./modules/cert');
require('./modules/course/course-prolongate');
require('./modules/course/lection');
require('./modules/course/oftalma/oftalma');
require('./modules/services/services');
require('./modules/services/services_free_booking');

// [[vegas]]
require('./custom');
